import { AgGridReact } from 'ag-grid-react';
import { columnDefs, defaultColDef } from './utils/definitions-config.jsx';
import { getClassesForSpecificCohort } from '../../services/apiService.js';
import { useState } from 'react';
import 'ag-grid-enterprise';
import { filterLatestClasses } from '../../utils.js';
import moment from 'moment/moment.js';

function ManageClassroomTable({ allCohorts, activeTab }) {
  const [rowData, setRowData] = useState([]);
  const [selectedCohort, setSelectedCohort] = useState(null);

  const comparator = (data) => {
    return data?.filter((item) => new Date(item.endTime) < new Date());
  };

  const fetchInitialData = async (params) => {
    const latestCohort = allCohorts.reduce((prev, current) => {
      return new Date(current.createdOn) > new Date(prev.createdOn)
        ? current
        : prev;
    });

    try {
      const data = await getClassesForSpecificCohort(latestCohort?.name);
      const sortedData = comparator(data);
      const updatedData = filterLatestClasses(sortedData);
      setSelectedCohort(latestCohort?.name);
      setRowData(updatedData);
      return latestCohort;
    } catch (error) {
      console.error(error);
    } finally {
      const colDef = params.api.getColumnDef('cohort');
      const filter = {
        date: {
          dateFrom: moment().format('YYYY-MM-DD'),
          dateTo: null,
          type: 'lessThan',
          filterType: 'date',
        },
      };
      colDef.filterParams.values = [
        ...new Set(allCohorts.map((item) => item.name)),
      ];
      colDef.filterParams.defaultOption = latestCohort.name;
      params.api.setColumnDefs(params.api.getColumnDefs());
      params.api.setFilterModel(filter);
    }
  };

  const onGridReady = async (params) => {
    await fetchInitialData(params);
  };

  const onFilterChanged = async (params) => {
    try {
      const filterModel = params.api.getFilterModel();
      if (filterModel?.cohort?.state) {
        const selectedCohort = filterModel.cohort.state;
        const data = await getClassesForSpecificCohort(selectedCohort);
        const sortedData = comparator(data);
        const updatedData = filterLatestClasses(sortedData);
        setSelectedCohort(selectedCohort);
        setRowData(updatedData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const refreshData = async () => {
    const data = await getClassesForSpecificCohort(selectedCohort);
    const sortedData = comparator(data);
    const updatedData = filterLatestClasses(sortedData);
    setRowData(updatedData);
  };

  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: 16,
        border: '1px solid rgba(0,0,0,0.07)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
        overflow: 'hidden',
      }}
    >
      <div className='ag-theme-alpine' style={{ width: '100%' }}>
        <AgGridReact
          onGridReady={onGridReady}
          onFilterChanged={onFilterChanged}
          columnDefs={columnDefs(refreshData, activeTab)}
          defaultColDef={defaultColDef}
          rowData={rowData}
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          domLayout='autoHeight'
          rowHeight={50}
          animateRows={true}
          pagination={true}
          paginationPageSize={10}
          cacheBlockSize={10}
        />
      </div>
    </div>
  );
}

export default ManageClassroomTable;
